module.exports = __webpack_public_path__ + "static/img/produto_p.f96602e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina/produto_p.png
// module id = I1Fv
// module chunks = 0